import React, { useState, useEffect } from "react";
import { Stepper } from "../../components";
import { Dashboard, Leaderboard, CandidateFeedback, Invite, List } from "../";
import { LocalStorageService } from "../../../services";
import { useSelector } from "react-redux";
import HelpButton from "../../../components/button/helpButton";

// get user data from state
const authData = (state) => state.auth;

function Home() {
  const [currentStep, setcurrentStep] = useState(1);


  let handleStep = (num) => {
    setcurrentStep(num);
  };
  useEffect(() => {
    let check = LocalStorageService.getObject("path");
    if (check === "leaderBoard") {
      setcurrentStep(2);
    } else if (check === "invite") {
      setcurrentStep(5);
    } else {
      setcurrentStep(1);
    }
  }, []);

  return (
    <div>
      <Stepper onClick={handleStep} current={currentStep}>
        <div className="mb-12">
          {currentStep === 1 ? (
            <Dashboard />
          ) : currentStep === 2 ? (
            <Leaderboard />
          ) : currentStep === 3 ? (
            <List />
          ) : currentStep === 4 ? (
            <CandidateFeedback />
          ) : currentStep === 5 ? (
            <Invite />
          ) : null}
        </div>
      </Stepper>

      <HelpButton screen="login" />
    </div>
  );
}

export default Home;
